import { useMemo } from "react"

import { useScreenSize } from "shared/lib/useScreenSize"

export enum ProductPositionRowCellType {
  POSITION = "position",
  CLARIFICATION_REQUEST = "clarification-request",
  NAME = "name",
  VARIANT_KEY = "variant-key",
  QUANTITY = "quantity",
  DIMENSIONING = "dimensioning",
  REMARK = "remark",
  ADDONS = "addons",
  STATUS = "status",
  MENU = "menu"
}

export function useProductPositionRowCells({
  hideQuantity,
  showClarificationRequestColumn,
  columnPreset = "default"
}: {
  hideQuantity?: boolean
  showClarificationRequestColumn?: boolean
  columnPreset?: "default" | "selection"
}) {
  const { isTablet } = useScreenSize()

  const cells = useMemo(() => {
    let availableCells = Object.values(ProductPositionRowCellType)

    if (columnPreset === "selection") {
      availableCells = [
        ProductPositionRowCellType.POSITION,
        ProductPositionRowCellType.CLARIFICATION_REQUEST,
        ProductPositionRowCellType.NAME,
        ProductPositionRowCellType.VARIANT_KEY
      ]
      if (isTablet) {
        availableCells = availableCells.filter(
          cell => cell !== ProductPositionRowCellType.VARIANT_KEY
        )
      }
    } else if (isTablet) {
      availableCells = [
        ProductPositionRowCellType.POSITION,
        ProductPositionRowCellType.CLARIFICATION_REQUEST,
        ProductPositionRowCellType.NAME,
        ProductPositionRowCellType.QUANTITY,
        ProductPositionRowCellType.DIMENSIONING,
        ProductPositionRowCellType.REMARK,
        ProductPositionRowCellType.ADDONS,
        ProductPositionRowCellType.STATUS
      ]
    }
    if (!showClarificationRequestColumn) {
      availableCells = availableCells.filter(
        cell => cell !== ProductPositionRowCellType.CLARIFICATION_REQUEST
      )
    }
    if (hideQuantity) {
      availableCells = availableCells.filter(
        cell => cell !== ProductPositionRowCellType.QUANTITY
      )
    }

    return availableCells.map((cell, index) => ({
      key: cell,
      colIndex: index + 1
    }))
  }, [isTablet, showClarificationRequestColumn, hideQuantity, columnPreset])

  return { cells }
}
